import React from 'react'

export default function Error() {
  return (
    <div className='container text-center'>
      <h1>Error <small>code: 404</small></h1>
      <h3>Page not found</h3>
    </div>
  )
}
